import { Helmet, HelmetProvider } from 'react-helmet-async';
import favicon from '../imagenes/logoutm.png'
import ListarAutores from "../componentes/ListarAutores";

const Autores = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
                        <title>Autores - Sistema de Administración Museo UTM</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <ListarAutores />
        </>
    );
}

export default Autores;